var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',_vm._l((_vm.breadcrumbData),function(item,index){return _c('a-breadcrumb-item',{key:index},[_c('router-link',{attrs:{"to":{name: item.name}}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }